import { createReducer } from '@reduxjs/toolkit';
import { ViewMode, ViewModeShape } from './model';
import * as viewModeActions from './actions';
import * as lastStateActions from '../lastState/actions';

const initial: ViewModeShape = {
  viewMode: ViewMode.assets,
  expanded: true,
};

export const viewModeReducer = createReducer<ViewModeShape>(initial, (builder) =>
  builder
    .addCase(viewModeActions.changed, (s, a) => {
      s.viewMode = a.payload.viewMode;
    })
    .addCase(viewModeActions.expandedChanged, (s, a) => {
      s.expanded = a.payload.expanded;
    })
    .addCase(lastStateActions.applied, (s, a) => {
      s.viewMode = a.payload?.state.data.viewMode?.value ?? initial.viewMode;
      s.expanded = a.payload?.state.data.viewMode?.expanded ?? initial.expanded;
    }),
);
